import { useEffect } from 'react';

import { ResponseStatus } from '../../resources/@types/uccSchema';
import { ApiError } from '../../resources/ApiError';
import { INFLEARN_URL } from '../constants/urls';
import useClientAccountProfileQuery from '../queries/useClientAccountProfileQuery';

/**
 * 로그인한 유저의 권한 및 로그인 여부를 관리하는 훅
 */
export default function useCheckLoginSession(isRequired = false) {
  const {
    data: profile,
    isLoading,
    error,
  } = useClientAccountProfileQuery({
    keepPreviousData: true,
  });

  useEffect(() => {
    if (
      isRequired &&
      !!error &&
      error instanceof ApiError &&
      error.statusCode === ResponseStatus.UNAUTHORIZED
    ) {
      location.href = INFLEARN_URL.MAIN();
    }
  }, [error, isRequired]);

  return {
    isLoggedIn: Boolean(profile?.id),
    isAdmin: Boolean(profile?.isAdmin),
    isLoading,
  };
}
